export const photoTypes = {
  COVER: 'B',
  GALLERY: 'GL',
  DASHBOARD: 'D'
}
